import React, { useState } from "react";
// import Messages from "../../../../../../../../../../../components/Messages";
import Input from "../../../../../../../../../../../../components/Input";
import { generateSlug } from "../../../../../../../../../../../../helpers/common";

function ServiceName({app, update, messages}) {

    const [name, setName] = useState(app.name);

    return (
        <Input
            style={{padding: 0}}
            id={`app-${app._id}-name`}
            name='name'
            placeholder='App name'
            iconLeft='fas fa-cube'
            maxLength={50}
            isValid={messages.find(m => m.target === `app-${app._id}-name`) ? false : undefined}
            error={messages.find(m => m.target === `app-${app._id}-name`)?.message}
            value={name}
            onChange={e => {
                const {value} = e.target;
                update({
                    name: value,
                    code: value ? generateSlug(value) : '',
                });
                setName(value);
                setTimeout(() => {
                    document.getElementById(`app-${app._id}-name`)?.focus()
                }, 50)
            }}
            autoComplete="one-time-code"
            required
        />
    )
}

export default ServiceName